import { render, staticRenderFns } from "./CreateSentence.vue?vue&type=template&id=2de333b5&scoped=true&"
import script from "./CreateSentence.vue?vue&type=script&lang=js&"
export * from "./CreateSentence.vue?vue&type=script&lang=js&"
import style0 from "./CreateSentence.vue?vue&type=style&index=0&id=2de333b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de333b5",
  null
  
)

export default component.exports